import React from 'react';
import PropTypes from 'prop-types';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import {
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
  TimelineItem,
} from '@mui/lab';
import { Typography } from '@mui/material';

export default function FinishedLevel({ title, levelKey }) {
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineConnector />
        <TimelineDot>
          <RocketLaunchRoundedIcon />
        </TimelineDot>
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent
        sx={{
          py: '12px',
          px: 2,
        }}
      >
        <Typography variant="h6" component="span" sx={{ opacity: 0.5 }}>
          {levelKey}
        </Typography>
        <Typography
          sx={{
            opacity: 0.5,
            whiteSpace: {
              xs: 'normal',
              md: 'nowrap',
            },
          }}
        >
          {title}
        </Typography>
      </TimelineContent>
    </TimelineItem>
  );
}

FinishedLevel.propTypes = {
  title: PropTypes.string.isRequired,
  levelKey: PropTypes.string.isRequired,
};
